import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { getAuth, signOut } from "firebase/auth";
import app from "./firebase";
import { useAuth } from "./context/AuthContext";

function Navbar() {
  const location = useLocation();
  const navigate = useNavigate();
  const auth = getAuth(app);
  const { currentUser, credits } = useAuth();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate("/login");
    } catch (error) {
      console.error("Error signing out:", error);
    }
  };

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  const displayName = currentUser?.displayName || currentUser?.email?.split("@")[0] || "User";

  if (!currentUser) return null;

  return (
    <nav className="navbar">
      <div className="navbar-brand">Nottsify</div>

      <button className="mobile-menu-btn" onClick={toggleMenu}>
        <i className={`fas ${isMenuOpen ? "fa-times" : "fa-bars"}`}></i>
      </button>

      <div className={`nav-links ${isMenuOpen ? "open" : ""}`} onClick={() => setIsMenuOpen(false)}>
        <Link to="/" className={`nav-link ${location.pathname === "/" ? "active" : ""}`}>Audio</Link>
        <Link to="/video" className={`nav-link ${location.pathname === "/video" ? "active" : ""}`}>Video</Link>
        <Link to="/youtube" className={`nav-link ${location.pathname === "/youtube" ? "active" : ""}`}>YouTube</Link>
        <Link to="/pptpage" className={`nav-link ${location.pathname === "/pptpage" ? "active" : ""}`}>PPT</Link>
        <Link to="/addtext" className={`nav-link ${location.pathname === "/addtext" ? "active" : ""}`}>Add Text</Link>


        {currentUser && (
          <div className="user-info-group">
            <span className="credits-badge">
              💰 {credits !== null ? credits : "—"} Credits
            </span>
            <span className="user-badge">
              👤 {displayName}
            </span>
          </div>
        )}

        <button
          onClick={(e) => { e.stopPropagation(); handleLogout(); }}
          className="nav-link logout-btn"
        >
          Logout
        </button>
      </div>
    </nav>
  );
}

export default Navbar;
